import { BaseWidgetModel } from './base'
import { ModuleNameEnum, WidgetModelNames } from '~/enums/siteEnum'
import { hasOwn } from '~/utils'
import { generateDefaultBackground } from '~/site/model/helper'
import { DefaultTemplate } from '~/enums/templateEnum'
import { DefaultImage } from '~/enums/defaultImageEnum'
import { MissionCenterTypeEnums } from '~/enums/data'

export class MissionCenterSettingModel extends BaseWidgetModel {
  constructor(options) {
    super(options)
    this.name = WidgetModelNames.MissionCenterSettingModel
    this.moduleName = ModuleNameEnum.MissionCenter
    this.iconEnabled = hasOwn(options, 'iconEnabled', '', false)
    this.background = hasOwn(options, 'background', '', generateDefaultBackground({ backgroundColor: 'white' }))
    this.textColor = hasOwn(options, 'textColor', '', generateDefaultBackground({ backgroundColor: '#000' }))
    this.submitColor = hasOwn(options, 'submitColor', '', generateDefaultBackground({ backgroundColor: 'white' }))
    this.submitBackground = hasOwn(options, 'submitBackground', '', generateDefaultBackground({ backgroundColor: '#3D46F5' }))
    this.getColor = hasOwn(options,'getColor', '', generateDefaultBackground({ backgroundColor: 'white' }))
    this.getBackground = hasOwn(options,'getBackground', '', generateDefaultBackground({ backgroundColor: '#009A29' }))
    this.doneColor = hasOwn(options,'doneColor', '', generateDefaultBackground({ backgroundColor: 'white' }))
    this.doneBackground = hasOwn(options,'doneBackground', '', generateDefaultBackground({ backgroundColor: '#8E8E8E' }))
    this.rowBackground = hasOwn(options,'rowBackground', '', generateDefaultBackground({ backgroundColor: '#F7F8F8' }))
    this.icon = hasOwn(options, 'icon', '', generateDefaultBackground({ backgroundImage: DefaultImage.missionCenterIcon }))
    this.title = hasOwn(options, 'title', '', DefaultTemplate.missionCenter.title)

    this.__onMenuSelected = function (model, context) {
      context.$store.commit('site/SET_MISSION_CENTER_VISIBLE', true)
      context.$nextTick(() => {
        document.querySelector('.edit-content__center--wrapper').scrollTop = 0
      })
    }

    this.__mockData = [
      {
        task_id: 1,
        name: '任务1',
        type: MissionCenterTypeEnums.PwaLogin,
        gifts: [
          {
            status: 3,
            gift_list: [
              {
                gift_goods_logo: DefaultImage.store,
                num: 100
              }
            ]
          }
        ]
      },
      {
        task_id: 2,
        name: '任务2',
        type: MissionCenterTypeEnums.PwaLogin,
        gifts: [
          {
            status: 2,
            gift_list: [
              {
                gift_goods_logo: DefaultImage.store,
                num: 100
              },
              {
                gift_goods_logo: DefaultImage.store,
                num: 100
              }
            ]
          }
        ]
      },
      {
        task_id: 3,
        name: '任务3',
        type: MissionCenterTypeEnums.PwaLogin,
        gifts: [
          {
            status: 1,
            gift_list: [
              {
                gift_goods_logo: DefaultImage.store,
                num: 100
              },
              {
                gift_goods_logo: DefaultImage.store,
                num: 100
              },
              {
                gift_goods_logo: DefaultImage.store,
                num: 100
              }
            ]
          }
        ]
      }
    ]

    this.__getLang = () => {
      const { title } = this
      return {
        title
      }
    }

    this.getMenuInfo = () => {
      return {
        id: this.id,
        title: 'missionCenter',
        name: this.moduleName,
        icon: 'icon-customer-nor',
        draggable: false,
        isDefault: false
      }
    }
  }
}
